function insertPlaceholders(message, placeholders) {
  const PLACEHOLDER_REGEX = /({{[a-zA-Z0-9]+}})/g;
  const parts = message.split(PLACEHOLDER_REGEX).filter(Boolean);
  return parts.map(part => {
    if (part.match(PLACEHOLDER_REGEX)) {
      const key = part.replace(/[{}]+/g, '');
      return placeholders[key];
    }
    return part;
  });
}

export { insertPlaceholders as default };
